import { useIntl } from 'react-intl';

import { SiteLocale } from '@src/generated/dato-cms';
import { i18nConfig } from '@src/i18n/locales';

export const useLocale = () => {
  const intl = useIntl();

  return (intl.locale || i18nConfig.defaultLocale) as SiteLocale;
};
